import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKlookComponent } from './simple-icons-klook.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKlookComponent ],
    exports:      [ SimpleIconsKlookComponent ],
    bootstrap:    []
})
export class SimpleIconsKlookModule {}
